enum InfoVariant {
  Gray = 'gray',
  Orange = 'orange',
}

export default InfoVariant;